<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="点号" prop="pointCode">
              <a-input placeholder="请输入点号" v-model="model.pointCode"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上限" prop="standardTop">
              <a-input-number placeholder="请输入上限" style="width: 100%" v-model="model.standardTop" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="下限" prop="standardBottom">
              <a-input-number placeholder="请输入下限" style="width: 100%" v-model="model.standardBottom" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否强制" prop="isForce">
              <j-switch v-model="model.isForce"></j-switch>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否启用" prop="enabled">
              <j-switch v-model="model.enabled"></j-switch>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'AutoRunPointValConfigForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          pointCode: [
            { required: true, message: '请输入点号!' },
          ],
          isForce: [
            { required: true, message: '请输入是否强制!' },
          ],
          enabled: [
            { required: true, message: '请输入是否启用!' },
          ],
        },
        url: {
          add: "/event/autoPointValConfig/add",
          edit: "/event/autoPointValConfig/edit",
          queryById: "/event/autoPointValConfig/queryById"
        }
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            const expressionParts = [];
            if (typeof that.model.standardTop === 'number') {
              expressionParts.push(` value <= ${that.model.standardTop}`);
            }
            if (typeof that.model.standardBottom === 'number') {
              expressionParts.push(` value >= ${that.model.standardBottom}`);
            }
            if (!expressionParts.length) {
              that.$message.warning('上、下限请至少填写一项');
              return;
            }
            that.model.expression = expressionParts.join(' and ');
            httpAction(httpurl, that.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            });
          }

        });
      },
    }
  }
</script>